import {Link} from "react-router-dom";
import {Breadcrumb} from "antd";
import {DashboardWrapper} from "../../../../../layouts/dashboard-wrapper";
import {StyledPageHeader} from "../../../../../styles/dashboard/calls/calls";
import {useGoogleCalendarConnection} from "../../../../../react-query-hooks/connect-calendar/useGoogleCalendarConnection";
import {
  StyledAutomationsPageContent,
  StyledIntegrationDetailCard,
  StyledIntegrationDetailHeader,
  StyledIntegrationDetailLayout,
} from "../../automations.style";
import {IntegrationConnectionVisual} from "../components/IntegrationConnectionVisual";
import {IntegrationConnectPanel} from "../components/IntegrationConnectPanel";
import {GoogleMeetIcon} from "../../icons/google-meet-icon";

const MEET_BULLET_POINTS = [
  "Connect your Google calendar to enable Google meet for bookings",
  "Select Google meet as a location when creating 1:1 sessions or live events",
  "Every booking automatically includes a unique Google Meet link",
  "Meeting details are added to your calendar and shared with attendees",
];

export function GoogleMeetIntegrationPage() {
  const {isConnected, connect, disconnect, isConnecting, isDisconnecting} =
    useGoogleCalendarConnection();

  return (
    <DashboardWrapper pageTitle="Google meet">
      <StyledPageHeader>Automations</StyledPageHeader>
      <StyledAutomationsPageContent>
        <StyledIntegrationDetailHeader>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/automations?tab=integrations">Integrations</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Google meet</Breadcrumb.Item>
          </Breadcrumb>
        </StyledIntegrationDetailHeader>

        <StyledIntegrationDetailCard>
          <StyledIntegrationDetailLayout>
            <IntegrationConnectionVisual />
            <IntegrationConnectPanel
              title="Use Google meet for your bookings"
              bulletPoints={MEET_BULLET_POINTS}
              connectLabel="Connect Google calendar"
              disconnectLabel="Disconnect Google calendar"
              isConnected={isConnected}
              onConnect={connect}
              onDisconnect={disconnect}
              isConnectLoading={isConnecting}
              isDisconnectLoading={isDisconnecting}
              disconnectedStatusMessage="You have not connected Google calendar to your Coachli account"
              connectedStatusMessage="Your Google calendar is connected. You can now use Google meet as a meeting location"
            />
          </StyledIntegrationDetailLayout>
        </StyledIntegrationDetailCard>
      </StyledAutomationsPageContent>
    </DashboardWrapper>
  );
}
